import { Component, Input } from '@angular/core';
import { PracticePathLog } from 'src/app/modules/practical-module-logs/models/practical-module-log.model';

@Component({
  selector: 'app-practice-path-log-item-content',
  templateUrl: './practice-path-log-item-content.component.html',
  styleUrls: ['./practice-path-log-item-content.component.scss']
})
export class PracticePathLogItemContentComponent {
  @Input() practicePathLog:PracticePathLog;
  
  /**
   * Determines if the log has data to show.
   * 
   * @returns true if the log has data to show, false otherwise
   */
  protected hasNoLogData():boolean {
    return this.practicePathLog.oldData == null && this.practicePathLog.newData == null;
  }
}
